import React from 'react';
import CreateSubCategoryState from './createSubCategoryState/CreateSubCategoryState';
import CreateSubCategoryControlPanel from './components/CreateSubCategoryControlPanel/CreateSubCategoryControlPanel';
import Forms from './components/Forms/Forms';
import ModalWindows from './components/ModalWindows/ModalWindows';
// import style from './index.module.scss';

const CreateSubCategoryPage: React.FC = () => {
	return (
		<CreateSubCategoryState>
			<CreateSubCategoryControlPanel />
			<Forms />
			<ModalWindows />
		</CreateSubCategoryState>
	);
};

export default CreateSubCategoryPage;
